import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { APOLLO_OPTIONS, APOLLO_NAMED_OPTIONS, NamedOptions } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloClientOptions, InMemoryCache } from '@apollo/client/core';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink): ApolloClientOptions<unknown> => ({
        cache: new InMemoryCache(),
        link: httpLink.create({ uri: '/api/graphql/shipments' }),
      }),
      deps: [HttpLink],
    },
    {
      provide: APOLLO_NAMED_OPTIONS,
      useFactory: (httpLink: HttpLink): NamedOptions => ({
        shipmentService: {
          cache: new InMemoryCache(),
          link: httpLink.create({ uri: '/api/graphql/shipments' }),
        },
      }),
      deps: [HttpLink],
    },
  ],
})
export class GraphqlModule {}
